module.exports = __webpack_public_path__ + "img/9788959524952.c812b4cf.jpg";